import {
   DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST,
   MOTOR_CYCLE_COVERAGE_TYPES, YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import {isInLabelValueArrayAsString} from "@utils/validators";



export const ValidateStep4Data = (data) => {

    const msgList = [];

    if(!isInLabelValueArrayAsString(data.levelOfCover,MOTOR_CYCLE_COVERAGE_TYPES)) {
       msgList.push({
          name : 'levelOfCover',
          message : 'Please select the level of cover'
       });
    }
    
    if(!isInLabelValueArrayAsString(data.termsAgreement,YES_NO_CHOICE_OPTIONS)) {
       msgList.push({
          name : 'termsAgreement',
          message : 'Please select if you agree to the terms and conditions'
       });
    }
    
    return msgList;

}